import { render, staticRenderFns } from "./RuleExpression.vue?vue&type=template&id=20513658&scoped=true"
import script from "./RuleExpression.vue?vue&type=script&lang=js"
export * from "./RuleExpression.vue?vue&type=script&lang=js"
import style0 from "./RuleExpression.vue?vue&type=style&index=0&id=20513658&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20513658",
  null
  
)

export default component.exports